import React, { Fragment } from 'react';
import { View, StyleSheet, Text } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginVertical: 10,
    fontFamily: 'Roboto',
  },
  row: {
    paddingTop: 7,
    marginBottom: 7,
    borderTop: 0.5,
    borderColor: '#6c757d',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'Roboto',
  },
  header: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: 10,
  },
  pos: {
    width: '10%',
    fontFamily: 'Roboto',
  },
  description: {
    width: '60%',
    fontFamily: 'Roboto',
  },
  amount: {
    width: '30%',
    fontFamily: 'Roboto',
  },
  rowContent: {
    fontFamily: 'Roboto',
  },
});

const TableHeader = ({
  translate,
  fontSize,
}: {
  translate: Function;
  fontSize: number;
}) => (
  <View style={[styles.row]} key={'header'}>
    <Text style={[styles.pos, styles.header, { fontSize }]}>
      {translate('MerchantOrder:deliveryNotePosition')}
    </Text>
    <Text style={[styles.description, styles.header, { fontSize }]}>
      {translate('Common:description')}
    </Text>
    <Text style={[styles.amount, styles.header, { fontSize }]}>
      {translate('Common:amount')}
    </Text>
  </View>
);

const TableRows = ({
  items,
  fontSize,
}: {
  items: {
    name: string;
    amount: number | string;
  }[];
  fontSize: number;
}) => {
  const rows = items.map((item, index) => (
    <View style={styles.row} key={index}>
      <Text style={[styles.pos, styles.rowContent, { fontSize }]}>
        {index + 1}
      </Text>
      <Text style={[styles.description, styles.rowContent, { fontSize }]}>
        {item.name}
      </Text>
      <Text style={[styles.amount, styles.rowContent, { fontSize }]}>
        {item.amount}
      </Text>
    </View>
  ));
  return <Fragment>{rows}</Fragment>;
};

const ReactPdfTable = ({
  items,
  translate,
}: {
  items: {
    name: string;
    amount: number | string;
  }[];
  translate: Function;
}) => {
  const fontSizes = getFontSize(items.length);
  return (
    <View style={styles.tableContainer}>
      <TableHeader translate={translate} fontSize={fontSizes[1]} />
      <TableRows items={items} fontSize={fontSizes[1]} />
    </View>
  );
};

const getFontSize = (itemsLength: number) => {
  if (itemsLength > 10) {
    return [4, 5];
  }
  if (itemsLength > 8) {
    return [6, 8];
  }
  return [8, 10];
};

export default ReactPdfTable;
